// extracted by mini-css-extract-plugin
export var author = "author-list-item-module--author--8398d";
export var authorContent = "author-list-item-module--author-content--e6e7f";
export var category = "author-list-item-module--category--0e84e";
export var description = "author-list-item-module--description--53fdd";
export var header = "author-list-item-module--header--71b96";
export var headline = "author-list-item-module--headline--c246b";
export var headlinePost = "author-list-item-module--headline-post--381f0";
export var image = "author-list-item-module--image--6daba";
export var paragraph = "author-list-item-module--paragraph--8761c";
export var readAll = "author-list-item-module--read-all--d2737";
export var socialMediaList = "author-list-item-module--social-media-list--a0b63";